// ==============================|| OVERRIDES - INPUT LABEL ||============================== //
import type { Theme } from '@mui/material';

export default function InputLabel(theme: Theme) {
    return {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: theme.palette.grey[600],
                },
                outlined: {
                    lineHeight: '1em',
                    marginTop: '-2px',
                    '&.MuiInputLabel-sizeSmall': {
                        marginTop: 0,
                    },
                    '&.MuiInputLabel-shrink': {
                        background: theme.palette.background.paper,
                        padding: '0 8px',
                        marginTop: 0,
                        marginLeft: -6,
                        lineHeight: '1.4375em',
                    },
                },
            },
        },
    };
}
